import React, { Fragment, useState } from 'react';
import '../styles/Project.css';
import p1 from '../components/images/Online learning-amico.png';
import p2 from '../components/images/compiler.png';
import p3 from './images/portfolio.png';
import p4 from './images/Ecommerceog.png';
import p5 from './images/Sign up-bro.png';
import p6 from './images/Forest-pana.png';
import '../styles/internship.css';
import { MDBIcon } from 'mdb-react-ui-kit';

const projectsData = [
  {
    id: 1,
    img: p1,
    title: 'Kickstart E-learning',
    description: "Kickstart is own e learned website with helps learn & practice coding in one platform.kickstart is also helps you to prepare for interviews",
    link: 'https://kikstart.netlify.app/'
  },
  {
    id: 2,
    img: p2,
    title: 'Kickstart-content writtings',
    description: "It was a paid content writting service with minimal price that includes writting resumes,Articles,Blogs,PPTs, Word documents and making portfolios and bussiness websites and more ",
    link: 'https://kickstartcareers.netlify.app/'
  },
  {
    id: 3,
    img: p3,
    title: 'Personal Portfolio',
    description: 'I made my Responsive web Portfolio  Using react js Framework ,CSS and MDB Bootstrap a commonly used ui library and deployed this wedsite on firebase account.',
    link: 'https://rajivmuddukuppam.netlify.app/'
  },
  {
    id: 4,
    img: p4,
    title: 'E-commerce application',
    description: 'Developed a responsive ecommerce website utilizing React.js, prioritizing user experience and seamless navigation. Implemented intuitive design elements to enhance product discovery',
    link: 'https://64e03e6fefff1a197b41aadf--fastidious-fox-a85bd7.netlify.app/'
  },
  {
    id: 5,
    img: p5,
    title: 'Job Registration form ',
    description: 'Created a user-friendly and adaptable student registration form using JavaScript for interactive features, HTML for structure, and CSS for design.',
   
  },
  {
    id: 6,
    img: p6,
    title: 'Wild animal',
    description: 'This is a basic example, but it demonstrates how to define and call functions within React components using functional components and arrow functions',
    
  },
];

const Project = () => {
  const [showModal, setShowModal] = useState(false);
  const [displayedProjects, setDisplayedProjects] = useState(projectsData.slice(0, 3));

  const showMoreProjects = () => {
    setDisplayedProjects(projectsData);
    setShowModal(true);
  };

  const showLessProjects = () => {
    setDisplayedProjects(projectsData.slice(0, 3));
    setShowModal(false);
  };

  return (
    <Fragment>
      <div className='p-container'>
        {displayedProjects.map((project) => (
          <div key={project.id} className='p-box'>
            <img src={project.img} className='p-img' alt={project.title} />
            <h3 className='p-h3'>{project.title}</h3>
            <p className='p-p'>{project.description}</p>
            <a href={project.link} target="_blank" rel="noopener noreferrer"><button className='p-button'>Show</button></a>
          </div>
        ))}
        {projectsData.length > 3 && (
          <div>
            {showModal ? (
              <p className='showmore' onClick={showLessProjects}><MDBIcon fas icon="angle-double-up" /> Show Less</p>
            ) : (
              <p className='showmore' onClick={showMoreProjects}><MDBIcon fas icon="angle-double-right" /> Show More</p>
            )}
          </div>
        )}
      </div>

      {showModal && (
        <div className='modal'>
          <div className='modal-content'>
            <span className='close' onClick={() => setShowModal(false)}>&times;</span>
            {projectsData.map((project) => (
              <div key={project.id} className='p-box'>
                <img src={project.img} className='p-img' alt={project.title} />
                <h3 className='p-h3'>{project.title}</h3>
                <p className='p-p'>{project.description}</p>
                <a href={project.link} target="_blank" rel="noopener noreferrer"><center><button className='p-button'>Show</button></center></a>
              </div>
            ))}
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Project;
